import React from "react";

export default function Women(){
    return(
        <div>
            <p style={{fontSize: '40px', textAlign: 'center'}}>Women</p>
        </div>
    )
}